import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import * as yup from 'yup';

import Aquarius from '../../../../assets/images/quiz/astrology-signs/Aquarius.svg';
import Aries from '../../../../assets/images/quiz/astrology-signs/Aries.svg';
import Cancer from '../../../../assets/images/quiz/astrology-signs/Cancer.svg';
import Capricorn from '../../../../assets/images/quiz/astrology-signs/Capricorn.svg';
import Gemini from '../../../../assets/images/quiz/astrology-signs/Gemini.svg';
import Leo from '../../../../assets/images/quiz/astrology-signs/Leo.svg';
import Libra from '../../../../assets/images/quiz/astrology-signs/Libra.svg';
import Pisces from '../../../../assets/images/quiz/astrology-signs/Pisces.svg';
import Sagittarius from '../../../../assets/images/quiz/astrology-signs/Sagittarius.svg';
import Scorpio from '../../../../assets/images/quiz/astrology-signs/Scorpio.svg';
import Taurus from '../../../../assets/images/quiz/astrology-signs/Taurus.svg';
import Virgo from '../../../../assets/images/quiz/astrology-signs/Virgo.svg';
import Button from '../../../common/button/button';
import { useStores } from '../../../common/root-store-provider/root-store-provider';
import styles from './date-of-birth-step.module.scss';

const DATE_FORMAT = 'YYYY-MM-DD';

const DateOfBirth = observer(
  ({ value, onChange }: { value?: Date; onChange: (value: Date) => void }) => {
    const formSchema = useMemo(
      () =>
        yup.object().shape({
          dateOfBirth: yup
            .date()
            .transform((value) => dayjs(value).toDate())
            .max(dayjs().endOf('day'), 'Please, enter a valid date')
            .required(),
        }),
      [],
    );

    const { quizStore } = useStores();

    const { values, resetForm, handleChange, handleSubmit, errors, isValid } =
      useFormik<{ dateOfBirth: string }>({
        initialValues: { dateOfBirth: dayjs().format(DATE_FORMAT) },
        validationSchema: formSchema,
        onSubmit: (values) => {
          onChange(dayjs(values.dateOfBirth).toDate());
        },
      });

    useEffect(() => {
      resetForm(
        value == null
          ? undefined
          : { values: { dateOfBirth: dayjs(value).format(DATE_FORMAT) } },
      );
    }, [value, resetForm]);

    let signImage;
    switch (quizStore.getAstrologySing(dayjs(values.dateOfBirth).toDate())) {
      case 'Capricorn': {
        signImage = <Capricorn />;
        break;
      }
      case 'Aquarius': {
        signImage = <Aquarius />;
        break;
      }
      case 'Pisces': {
        signImage = <Pisces />;
        break;
      }
      case 'Aries': {
        signImage = <Aries />;
        break;
      }
      case 'Taurus': {
        signImage = <Taurus />;
        break;
      }
      case 'Gemini': {
        signImage = <Gemini />;
        break;
      }
      case 'Cancer': {
        signImage = <Cancer />;
        break;
      }
      case 'Leo': {
        signImage = <Leo />;
        break;
      }
      case 'Virgo': {
        signImage = <Virgo />;
        break;
      }
      case 'Libra': {
        signImage = <Libra />;
        break;
      }
      case 'Scorpio': {
        signImage = <Scorpio />;
        break;
      }
      case 'Sagittarius': {
        signImage = <Sagittarius />;
        break;
      }
    }

    return (
      <Form className={styles.form} onSubmit={handleSubmit}>
        {signImage}
        <Form.Group className={styles.controlGroup}>
          <Form.Control
            className={styles.control}
            type="date"
            name="dateOfBirth"
            required={true}
            value={values.dateOfBirth}
            onChange={handleChange}
            isInvalid={errors.dateOfBirth != null}
          />
          <Form.Control.Feedback
            className={styles.controlFeedback}
            type="invalid">
            {errors.dateOfBirth}
          </Form.Control.Feedback>
        </Form.Group>
        <Button
          className={styles.submitButton}
          type="submit"
          disabled={!isValid}>
          Next
        </Button>
      </Form>
    );
  },
);

export default DateOfBirth;
